

















import { PosRoute } from 'gl-ms-positions';
import moment from 'moment';
import numbers from './numbers.vue';

export default {
    data() {
        return {};
    },
    components: {
        numbers,
    },
    props: ['route', 'routeChanged', 'originalRoute', 'title', 'originalTitle'],
    computed: {
        truckSummaries(this: any) {
            if (this.route) {
                return [`${this.$t('fleetPlanning.tripTakeHourDistance')}${Math.floor(this.route.distance / 1000)} km`];
            }

            return [];
        },

        messages(this: any) {
            if (this.route && this.route.messages) {
                return this.route.messages;
            }

            return [];
        },
    },

    methods: {},
};
